import React from 'react';

const cx = (...names) => names.filter(Boolean).join(' ');

/**
 * A row of mutually exclusive toggle buttons (aria-pressed), like the
 * canvas's grid / list / table switch. options: [{id, label, icon, disabled,
 * title, describedBy}]; with an icon the label is the button's accessible
 * name only; a disabled one stays focusable (aria-disabled), cannot be
 * chosen, and points at the visible text that says why (describedBy).
 */
export function SegmentedControl({ options, value, onChange, label, className, size = 'md' }) {
  return (
    <div role="group" aria-label={label} className={cx('ui-segmented', `ui-segmented--${size}`, className)}>
      {options.map(({ id, label: optionLabel, icon: Icon, disabled, title, describedBy }) => {
        const pressed = id === value;
        return (
          <button
            key={id}
            type="button"
            aria-pressed={pressed}
            aria-label={Icon ? optionLabel : undefined}
            title={title || (Icon ? optionLabel : undefined)}
            aria-disabled={disabled ? 'true' : undefined}
            aria-describedby={describedBy}
            className={cx('ui-segmented__option', pressed && 'is-selected', disabled && 'is-disabled')}
            onClick={() => { if (!pressed && !disabled) onChange(id); }}
          >
            {Icon ? <Icon size={18} /> : optionLabel}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
